enum Variant {
  SUCCESS = 'success',
  ERROR = 'error'
}

export default Variant;
